// combatpro/companions/companionApi.js
//
// Combat PRO - Animal Companion feed client (G268). Reads the account's saved
// animals through the server-authoritative /v1/animal-companions routes, which
// sit behind the Combat PRO entitlement and are scoped to the signed-in account.
// The server decides eligibility; the client never admits an animal on its own.
// The one write is the trainer a player chooses in the Player Pets & Animal
// Companions modal (G270), validated by the server against the saved shortlist.
// No optional chaining. No nullish coalescing. No em dash.

import API from '../../api';

export var COMPANIONS_PATH = '/v1/animal-companions';

function errorOf(err) {
  var res = err && err.response ? err.response : null;
  var data = res && res.data ? res.data : {};
  return { status: res ? res.status : 0, error: data.error || 'request_failed', reasons: data.reasons || [], companion: data.companion || null };
}

export async function loadOwnCompanions() {
  try {
    var res = await API.get(COMPANIONS_PATH);
    return { ok: true, records: (res && res.data && res.data.records) ? res.data.records : [] };
  } catch (err) {
    return Object.assign({ ok: false, records: [] }, errorOf(err));
  }
}

export async function loadCombatFeed(owners) {
  try {
    var res = await API.get(COMPANIONS_PATH + '/combat-feed', { params: { owner: owners || [] }, paramsSerializer: { indexes: null } });
    return Object.assign({ ok: true }, res ? res.data : {});
  } catch (err) {
    return Object.assign({ ok: false, owners: [] }, errorOf(err));
  }
}

export async function requestCombatEntry(companionId, owners) {
  try {
    var res = await API.post(COMPANIONS_PATH + '/combat-entry', { companion_id: companionId, owners: owners || [] });
    return Object.assign({ ok: true }, res ? res.data : {});
  } catch (err) {
    return Object.assign({ ok: false }, errorOf(err));
  }
}

// Record (trainerId) or clear (null) the trainer chosen in the modal from the shortlist the Animal Training &
// Trainer Generator saved. Scheduling, progress and completion stay in the generator.
export async function selectTrainer(companionId, trainerId) {
  try {
    var res = await API.post(COMPANIONS_PATH + '/' + encodeURIComponent(companionId) + '/trainer-choice', { trainer_id: trainerId === undefined ? null : trainerId });
    return Object.assign({ ok: true }, res ? res.data : {});
  } catch (err) {
    return Object.assign({ ok: false }, errorOf(err));
  }
}
